export const IDENTITY_CONFIRMATION_NOT_MATCH_ERROR_CODE: string = "ERR_OA_0051";
export const IDENTITY_CONFIRMATION_FAILED_ERROR_CODE: string = "ERR_OA_0052";
